import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });

// スクロール制御の関数
function disableScroll() {
  $('body').addClass('is-menuopened');
  $('body').css('overflow', 'hidden');
}

function enableScroll() {
  $('body').removeClass('is-menuopened');
  $('body').css('overflow', '');
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('p-top')) {
    const header = document.querySelector('header.is-top');
    let vh = window.innerHeight;

    // スクロールイベント
    window.addEventListener('scroll', function () {
      if (window.scrollY > vh) {
        header.classList.remove('is-top');
      } else {
        header.classList.add('is-top');
      }
    });

    // リサイズイベント
    window.addEventListener('resize', function () {
      vh = window.innerHeight;
    });
  }
});

let lastWindowWidth = $(window).width();
const breakpoint = 1365;

// メニューの初期状態を設定
gsap.set('.sp-header .menu', {
  opacity: 0,
  visibility: 'hidden'
});

gsap.set('.inquiry-menu', {
  opacity: 0,
  visibility: 'hidden'
});

// メニューの状態管理用の関数
function closeSpMenu() {
  const $menuBtn = $('.sp-header .menu-btn');
  const $menu = $('.sp-header .menu');

  $menuBtn.removeClass('is-active');
  enableScroll();
  return gsap.to($menu, {
    opacity: 0,
    duration: 0.2,
    onComplete: () => {
      gsap.set($menu, { visibility: 'hidden' });
    }
  });
}

function closeInquiryMenu() {
  enableScroll();
  return gsap.to('.inquiry-menu', {
    opacity: 0,
    duration: 0.2,
    onComplete: () => {
      gsap.set('.inquiry-menu', { visibility: 'hidden' });
    }
  });
}

//ドロップダウン
function initDropdown() {
  $('.dropdown-trigger').off('mouseenter mouseleave click');

  if ($(window).width() > breakpoint) {
    // PC用イベント（hover）
    $('.dropdown-trigger').on({
      mouseenter: function () {
        $(this).find('.dropdown').stop(true, true).fadeIn(200);
        return false;
      },
      mouseleave: function () {
        $(this).find('.dropdown').stop(true, true).fadeOut(200);
        return false;
      }
    });
  } else {
    // SP用イベント（click）
    $('.dropdown-trigger').on('click', function (e) {
      e.preventDefault();
      $(this).find('.dropdown').stop(true, true).fadeToggle(200);
    });
  }
}

//inquiryメニュー
function initInquiryMenu() {
  $('.inquiry-btn').off('mouseenter mouseleave click');
  $('.inquiry-btn').on('click', function (e) {
    e.preventDefault();

    const $menu = $('.inquiry-menu');
    const isVisible = $menu.css('visibility') === 'visible';
    const $spMenu = $('.sp-header .menu');
    const isSpMenuVisible = $spMenu.css('visibility') === 'visible';

    if (!isVisible) {
      if (isSpMenuVisible) {
        closeSpMenu().then(() => {
          gsap.to($menu, {
            opacity: 1,
            visibility: 'visible',
            duration: 0.3,
            ease: 'power2.out'
          });
          disableScroll();
        });
      } else {
        gsap.to($menu, {
          opacity: 1,
          visibility: 'visible',
          duration: 0.3,
          ease: 'power2.out'
        });
        disableScroll();
      }
    } else {
      closeInquiryMenu();
      enableScroll();
    }
  });
}

// 初期化
$(document).ready(function () {
  initDropdown();
  initInquiryMenu();
});

// リサイズイベント
$(window).on('resize', function () {
  const currentWindowWidth = $(window).width();

  if (
    (lastWindowWidth <= breakpoint && currentWindowWidth > breakpoint) ||
    (lastWindowWidth > breakpoint && currentWindowWidth <= breakpoint)
  ) {
    initDropdown();
    initInquiryMenu();
  }

  lastWindowWidth = currentWindowWidth;
});

// SPメニューボタン
$('.sp-header .menu-btn').on('click', function () {
  const $menu = $('.sp-header .menu');
  const $menuBtn = $(this);
  const $inquiryMenu = $('.inquiry-menu');
  const isInquiryVisible = $inquiryMenu.css('visibility') === 'visible';

  if (!$menuBtn.hasClass('is-active')) {
    if (isInquiryVisible) {
      closeInquiryMenu().then(() => {
        $menuBtn.addClass('is-active');
        gsap.to($menu, {
          opacity: 1,
          visibility: 'visible',
          duration: 0.2
        });
        disableScroll();
      });
    } else {
      $menuBtn.addClass('is-active');
      gsap.to($menu, {
        opacity: 1,
        visibility: 'visible',
        duration: 0.2
      });
      disableScroll();
    }
  } else {
    closeSpMenu();
    enableScroll();
  }
  return false;
});

// SPサイズでの処理
function initSpMenu() {
  $('.footer-nav .nav .midashi').off('click');

  if (window.innerWidth <= 1080) {
    $('.footer-nav .nav .columns').hide();

    $('.footer-nav .nav .midashi').on('touchstart click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if ($(e.target).is('a') || $(e.target).parents('a').length > 0) {
        return true;
      }

      $(this).next('.columns').stop().slideToggle(200);
      $(this).toggleClass('is-active');
    });
  } else {
    $('.footer-nav .nav .columns').show();
  }
}

let previousWidth = window.innerWidth;

$(window).on('resize', function () {
  if ((previousWidth <= 1080 && window.innerWidth > 1080) ||
    (previousWidth > 1080 && window.innerWidth <= 1080)) {
    initSpMenu();
  }
  previousWidth = window.innerWidth;
});

// 初期化
$(document).ready(function () {
  initSpMenu();
});

//フロートボタン
$(function () {
  $(window).scroll(function () {
    const scrollTop = $(window).scrollTop();
    const footerPosition = $('footer').offset().top;
    const windowHeight = $(window).height();

    if (scrollTop > 500 && scrollTop + windowHeight < footerPosition) {
      $('.float-btns').addClass('is-show');
    } else {
      $('.float-btns').removeClass('is-show');
    }
  });
});
